module.exports = __webpack_public_path__ + "static/media/photo_petroleum.63bb6d33.jpg";